import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import PERM from 'constants/core/perm.const';
import { useCustomPermission } from 'providers/Access.provider';
import { selectAccessHasLockToken } from 'selectors/access.selectors';

export const useCheckoutPermissions = () => {
  const hasLockToken = useSelector(selectAccessHasLockToken);
  const rawCanApplyDiscount = useCustomPermission(PERM.canApplyDiscountAtCheckout);
  const rawCanChangePrice = useCustomPermission(PERM.canChangePriceAtCheckout);
  const rawCanVoidTransaction = useCustomPermission(PERM.canVoidTransaction);

  return useMemo(
    () => ({
      canApplyDiscount: !hasLockToken || rawCanApplyDiscount,
      canChangePrice: !hasLockToken || rawCanChangePrice,
      canVoidTransaction: !hasLockToken || rawCanVoidTransaction,
    }),
    [hasLockToken, rawCanApplyDiscount, rawCanChangePrice, rawCanVoidTransaction],
  );
};
